import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
};
const inviteSlice = createSlice({
  name: 'invite',
  initialState,
  reducers: {
    setUser(state, action) {
      return {
        ...state,
        user: action.payload,
      };
    },
    acceptInvite(state, action) {},
    declineInvite(state, action) {},
    sendAnswer(payload) {},
  },
});
export const inviteActions = inviteSlice.actions;
export const inviteReducer = inviteSlice.reducer;
